export const CHART_COLORS = [ 
  '#FF8327',
  '#33CB51',
  '#F8CEA7',
  '#4C7CFF',
  '#7F51FF',
  '#FF622E',
  '#2EC7FF',
  '#AAE71B',
  '#C165FF',
  '#EE2EFF',
  '#FFD500',
]